import { getWorldTransform, get } from '../../modules/scene';
import { virtualTargetId } from '../../modules/sceneGraph';
import * as THREE from 'three';

const position = new THREE.Vector3();
const rotation = new THREE.Quaternion();
const scale = new THREE.Vector3();
/**
 * If the Camera has a look at attached, return that, otherwise the
 * virtual target transform
 * @returns {Matrix4}
 */
export default function getTargetWorldMatrix(store, cameraId, initCameraTransform) {
  const cameraTransform = initCameraTransform ||  get(store, { id: cameraId, evalPlug: 'Transform' });
  const cameraData = get(store, { id: cameraId, evalPlug: 'Camera' });
  if (cameraTransform && cameraTransform.target) {
    const lookAtTarget = getWorldTransform(store, cameraTransform.target.nodeId);
    const offset = cameraData.offset;
    lookAtTarget.decompose(position, rotation, scale);
    return !offset ? lookAtTarget : lookAtTarget.compose(position.add(offset), rotation, scale);
  } else {
    return getWorldTransform(store, virtualTargetId);
  }
}



// WEBPACK FOOTER //
// ./src/translators/utils/getTargetWorldMatrix.js